/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import CustomCard from '../../../../components/CustomCard';
import { Box } from '@mui/material';
import { AddIcon, CategoriesIcon } from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import CustomTable from '../../../../components/table/CustomTable';
import CategoriesApp from '../Functionality/CategoriesApp';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import DeleteModal from '../../../Modals/DeleteModal';
import CreateCategory from '../Modal/CreateCategory';
import { CATEGORY_TYPE } from './../../../../pages/Dashboard/Contractors/EquipmentAndMaterial/Model/Model';


const Categories = () => {
    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        setResults,
        option,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        deleteShow,
        setDeleteShow,
        selectedCategoryForDelete,
        setSelectedCategoryForDelete,
        deleteCategory,
        createCategoryShow,
        setCreateCategoryShow,
        setModified,
        viewType,
        isAllChecked
    } = CategoriesApp();
    return (
        <>
            <CustomCard classCard='card-border-8px overflow-hidden' classContent='p-0'>
                <div className='d-flex align-items-center m-3 mb-4'>
                    <div className='d-flex align-items-center gap-2'>
                        <Box className='icon-circle-container'>
                            <CategoriesIcon />
                        </Box>
                        <p className='fs-14px font-color-text-950 ibl-font-w-600 m-0'>{t('categories')}</p>
                    </div>

                    <ButtonAction
                        id='btn_c_create'
                        name='create'
                        className='btn-icon-export ms-auto'
                        Icon={AddIcon}
                        onClick={() => setCreateCategoryShow(true)}
                    />
                </div>
                <div className='m-3'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={viewType}
                    />
                    <CustomTable
                        tableId={tableId}
                        searchId={searchId}
                        checkbox={false}
                        thead={thead}
                        tbody={tbody}
                        columnActions={true}
                        getActionsButtons={getActionsButtons}
                        showHeader={false}
                        isAllChecked={isAllChecked}
                    />
                    {pagination()}
                </div>
            </CustomCard>
            <DeleteModal
                show={deleteShow}
                onHide={() => {
                    setDeleteShow(false);
                    setSelectedCategoryForDelete(null);
                }}
                data={selectedCategoryForDelete}
                onClickFn={() => deleteCategory(selectedCategoryForDelete)}
                title_modal='delete_category'
                element_modal='category'
            />
            <CreateCategory
                show={createCategoryShow}
                onHide={() => setCreateCategoryShow(false)}
                titleModal='create_category'
                inputModal={t('enter_category_name')}
                icon={CategoriesIcon}
                type={CATEGORY_TYPE.CATEGORY}
                userId={contractorId}
                setModified={setModified}
            />
        </>
    );
};

export default Categories;
